<h1 class="h3 card-title text-center my-4">Choose Login Type</h1>
<p>Select how you want to login to the application.</p>
<button class="btn btn-lg btn-outline-primary w-100 my-3" (click)="testUserLogin()">Login as Test User</button>
<button class="btn btn-lg btn-outline-primary w-100" (click)="standardLogin()">Login via ADEConnect</button>
